<template>
	<div>
		<topTab ref="topTab" :tab-data="tabData" @tab-change="changePages">
			<lcsj-filter :show-search="false" more-text="更多筛选" @search="inputChange()">
			<template #query>
				<el-button v-if="$checkBtnPermission('/processInput/index', 'viewPage')" size="small" type="primary" class="el-icon-search" @click="inputChange()">搜索</el-button>
				<el-button v-if="$checkBtnPermission('/processInput/index', 'reset')" size="small" icon="el-icon-refresh" @click="clearAll">重置</el-button>
			</template>
			<template #actions></template>
			<el-form-item label="入库单号：">
					<el-input clearable v-model="formInline.inputStoreNo" size="small" placeholder="请输入入库单号" @keyup.enter.native="inputChange"></el-input>
				</el-form-item>
				<el-form-item label="来源采购单号：">
					<el-input clearable v-model="formInline.purchaseNo" size="small" placeholder="请输入来源采购单号" @keyup.enter.native="inputChange"></el-input>
				</el-form-item>
				<el-form-item label="入库类型：">
					<el-select v-model.number="formInline.inputType" placeholder="请选择入库类型" size="small" @change="search">
						<el-option label="全部" :value="0"></el-option>
						<el-option label="采购入库" :value="1"></el-option>
						<el-option label="手工入库" :value="2"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="入库时间：">
					<el-date-picker
						v-model="dateValue"
						clearable
						size="small"
						type="daterange"
						value-format="yyyy-MM-dd"
						format="yyyy-MM-dd"
						range-separator="~"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						@change="handleDateChange"
					></el-date-picker>
				</el-form-item>
			</lcsj-filter>
			<STable :columns="columnsData" :data="listData" :loading="loading" border height="480" @get-data="getListData">
				<template #inputStoreNo>
					<el-table-column align="center" label="入库单号" width="230">
						<template #default="scope">
							<el-link type="primary" size="small" @click="handleSeeDetail(scope.row)">{{ scope.row.inputStoreNo }}</el-link>
						</template>
					</el-table-column>
				</template>
				<template #operate>
					<el-table-column align="center" label="操作" width="90" fixed="right">
						<template #default="scope">
							<el-button type="text" size="small" @click="handleSeeDetail(scope.row)">详情</el-button>
						</template>
					</el-table-column>
				</template>
			</STable>
			<Pagination v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination>
		</topTab>
		<processInputDetail ref="processInputDetail"></processInputDetail>
	</div>
</template>

<script>
import { GetProcessInputStorePageList } from "@/api/processApi.js";
import processInputDetail from "./detail.vue";
export default {
	components: {
		processInputDetail
	},
	data() {
		return {
			activeTab: "1",
			tabData: [
				{
					key: "1",
					value: "入库单列表"
				}
			],
			pageShow: true,
			loading: false,
			listData: [],
			pageparm: {
				pageIndex: 1,
				pageSize: 10,
				total: 0
			},
			dateValue: [],
			formInline: {
				pageIndex: 1,
				pageSize: 10,
				inputStoreNo: "",
				purchaseNo: "",
				inputType: 0,
				startTime: null,
				endTime: null
			},
			columnsData: [],
			listColumns: [
				{ prop: "rowNumber", label: "序号", align: "center", width: "70", isKeep: true },
				{ slot: "inputStoreNo", label: "入库单号", align: "center", isKeep: true, width: "230" },
				{ prop: "inputTypeStr", label: "入库类型", align: "center", isKeep: true, width: "110" },
				{ prop: "purchaseNo", label: "来源采购单号", align: "center", isKeep: true, width: "220" },
				{ prop: "inputUserName", label: "入库人", align: "center", width: "100" },
				{ prop: "inputDate", label: "入库时间", align: "center", width: "170" },
				{ prop: "remark", label: "备注", align: "center", minWidth: "160" },
				{ prop: "creator", label: "创建人", align: "center", width: "100" },
				{ prop: "createTime", label: "创建时间", align: "center", width: "170" },
				{ slot: "operate", label: "操作", align: "center", isKeep: true, width: "90" }
			]
		};
	},
	created() {
		this.getCheckBox(this.listColumns.map((item) => item.label));
		this.getListData();
	},
	methods: {
			changePages(tab) {
				this.activeTab = tab;
			},
		getCheckBox(val) {
			let arr = this.listColumns.filter((v) => !val.includes(v.label));
			this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
		},
		handleDateChange(val) {
			if (val) {
				this.formInline.startTime = val[0];
				this.formInline.endTime = val[1];
			} else {
				this.formInline.startTime = null;
				this.formInline.endTime = null;
			}
			this.search();
		},
		// 后端 int 型筛选字段不接受 null/空串（System.Text.Json 会直接返回 400），统一归一化为 0（0=不筛选）
		normalizeQuery() {
			["inputType"].forEach((key) => {
				const val = this.formInline[key];
				if (val === null || val === undefined || val === "") this.formInline[key] = 0;
			});
		},
		getListData() {
			this.normalizeQuery();
			this.loading = true;
			GetProcessInputStorePageList(this.formInline)
				.then((res) => {
					this.loading = false;
					if (res.code == 1) {
						this.listData = res.data || [];
						this.pageparm.total = res.totalNumber;
					} else {
						this.listData = [];
						this.$message({ type: "info", message: res.msg });
					}
				})
				.catch(() => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		clearAll() {
			this.$data.formInline = this.$options.data.call(this).formInline;
			this.dateValue = [];
			this.search();
		},
		inputChange() {
			this.search();
		},
		callFather(parm) {
			this.formInline.pageIndex = parm.currentPage == undefined ? 1 : parm.currentPage;
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		},
		search() {
			this.formInline.pageIndex = 1;
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.getListData();
		},
		handleSeeDetail(row) {
			this.$refs.processInputDetail.showSeeDetailDialog(row);
		}
	}
};
</script>

<style scoped></style>
